import { store } from '@/decorators/store';
import { Priority } from '@/entities/Priority';
import { AbstractEntityStore } from '@/stores/AbstractEntityStore';

@store({ id: 'Priority' })
export class PriorityStore extends AbstractEntityStore<Priority> {
  protected entityIdKey = 'id';
  protected entityLabelKey = 'value';
  protected entityValueKey = 'value';
}
